module.exports = __webpack_public_path__ + "static/media/insta.b8658a4b.svg";